import { getTimeRangeLabel } from './dashboardOverviewUtils';

/**
 * Build a JSON snapshot from dashboard state already loaded on DashboardPage.
 * AI uses this only — no extra API calls.
 */
export const buildDashboardAiSnapshot = ({
  timeRange,
  salesOverviewPeriod,
  overviewBills,
  overviewSalesAmount,
  overviewExpenses,
  overviewProfit,
  totalCustomers,
  totalSuppliers,
  totalDueAmount,
  totalCreditCustomers,
  inventoryStats,
  lowStockItems,
  topProducts,
  creditCustomers,
  activityLogs,
  chartLabels,
  chartData,
  salesMetrics,
  trialStatus,
  subscriptionStatus,
  locationScope,
}) => ({
  generatedAt: new Date().toISOString(),
  timeRange: {
    key: timeRange,
    label: getTimeRangeLabel(timeRange),
  },
  locationScope: locationScope || 'all',
  overview: {
    totalBills: overviewBills,
    totalSalesAmount: overviewSalesAmount,
    totalExpenses: overviewExpenses,
    totalProfit: overviewProfit,
    totalCustomers,
    totalSuppliers,
    totalCreditDue: totalDueAmount,
    totalCreditCustomers,
    lowStockCount: inventoryStats?.lowStock ?? 0,
    outOfStockCount: inventoryStats?.outOfStock ?? 0,
  },
  alerts: {
    outOfStockCount: inventoryStats?.outOfStock ?? 0,
    lowStockCount: inventoryStats?.lowStock ?? 0,
    creditDueAmount: totalDueAmount,
    creditCustomerCount: totalCreditCustomers,
    trialDaysRemaining: trialStatus?.trialActive ? trialStatus.daysRemaining : null,
    subscriptionDaysRemaining: subscriptionStatus?.active ? subscriptionStatus.daysRemaining : null,
    planName: subscriptionStatus?.planName || trialStatus?.planName || null,
  },
  salesOverview: {
    period: salesOverviewPeriod,
    chartLabels: chartLabels || [],
    chartData: chartData || [],
    metrics: salesMetrics || {},
  },
  inventory: {
    totalProducts: inventoryStats?.totalProducts ?? 0,
    inStock: inventoryStats?.inStock ?? 0,
    lowStock: inventoryStats?.lowStock ?? 0,
    outOfStock: inventoryStats?.outOfStock ?? 0,
    lowStockItems: (lowStockItems || []).slice(0, 15).map((item) => ({
      productId: item.productId,
      productName: item.productName,
      currentStock: item.currentStock,
      minStockLevel: item.minStockLevel,
      stockStatus: item.stockStatus,
    })),
  },
  bestSellers: (topProducts || []).map((p) => ({
    productId: p.productId,
    productName: p.productName,
    quantitySold: p.quantitySold,
    totalRevenue: p.totalRevenue,
  })),
  pendingPayments: (creditCustomers || []).slice(0, 5).map((c) => ({
    customerId: c.id,
    customerName: c.name,
    balanceDue: c.balanceDue,
    lastPurchaseDate: c.lastPurchaseDate,
  })),
  recentActivity: (activityLogs || []).slice(0, 8).map((log) => ({
    action: log.action,
    entityType: log.entityType,
    description: log.description,
    createdAt: log.createdAt,
  })),
});

export default buildDashboardAiSnapshot;
